var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPdf = function SvgPdf(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212123",
    strokeWidth: 1.313,
    d: "M31.5 8.167V31.5a2.333 2.333 0 0 1-2.333 2.334H5.833A2.333 2.333 0 0 1 3.5 31.5v-28a2.333 2.333 0 0 1 2.333-2.333H24.5m7 7-7-7m7 7h-6.32a.68.68 0 0 1-.68-.68v-6.32",
    className: "pdf_svg__pdf-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212123",
    d: "M10.737 17.36v1.814h1.295c.422 0 .624-.076.777-.21a.87.87 0 0 0 .327-.692.89.89 0 0 0-.327-.7c-.153-.134-.355-.211-.777-.211zm1.41 2.85h-1.41v2.832H9.585v-6.718h2.562c.634 0 1.037.144 1.363.384.47.355.777.912.777 1.564 0 .653-.307 1.2-.777 1.555-.326.24-.73.384-1.363.384m2.942 2.832v-6.718h2.351c1.123 0 1.948.346 2.543.921a3.37 3.37 0 0 1 1.008 2.438c0 .97-.384 1.833-1.008 2.438-.595.576-1.42.921-2.543.921zm1.151-1.056h1.104c.883 0 1.478-.259 1.89-.7.384-.403.605-.96.605-1.603s-.22-1.2-.604-1.602c-.413-.442-1.008-.701-1.89-.701H16.24zm5.721 1.056v-6.718h3.935v1.056h-2.783v1.535h2.159v1.056h-2.16v3.071z",
    className: "pdf_svg__pdf-text"
  })));
};
export default SvgPdf;